import {tokens} from '@commercial-helios/ui/theme'
import React from 'react'
import styled from 'styled-components'

import Checkbox from '@helios/shared/components/checkbox'
import RichText from '@helios/shared/components/rich-text'
import {Text} from '@helios/shared/styles/typography'
import type {ConsentsState, MappedConsents, OnConsentChange} from '@helios/shared/types/consents'
import {ConsentTypes} from '@helios/shared/types/consents'

export interface Props {
    isExplicit: boolean
    consentsState: ConsentsState
    consents: MappedConsents
    error?: string
    onConsentChange: OnConsentChange
    type: ConsentTypes
}

export const Consents = ({
    consentsState,
    isExplicit,
    consents,
    onConsentChange,
    error,
    type,
}: Props) =>
    type !== ConsentTypes.None ? (
        <ConsentsWrapper>
            {isExplicit ? (
                <Checkbox
                    label={consents.process}
                    onChange={(value) => onConsentChange('process', value)}
                    checked={consentsState.process.value}
                    error={consentsState.process.error}
                    showErrorLabel={false}
                />
            ) : (
                <RichText variant="label-base" color="muted" content={consents.process} />
            )}

            {consents.communication.map(({id, label}, index) => (
                <Checkbox
                    key={id}
                    label={label}
                    onChange={(value) => onConsentChange(id, value)}
                    checked={consentsState[id]?.value}
                    error={consentsState[id]?.error}
                    showErrorLabel={false}
                    data-testid={`consent-${index}`}
                />
            ))}

            {error && (
                <Text variant="label-base" color="error">
                    {error}
                </Text>
            )}
        </ConsentsWrapper>
    ) : null

const ConsentsWrapper = styled.div`
    display: grid;
    row-gap: ${tokens.spacing12};
`
